import { createAsyncThunk } from "@reduxjs/toolkit";
import { getToken } from '../../../utils/common';
import {
  getV1Company,
} from "../../../api-client/api.rbac/api";



export const fetchCompanies = createAsyncThunk(
  "reports-title/fetchCompanies",
  async () => {
    const response = await getV1Company({ ...getToken() });
    return response;
  }
);
